import axios from 'axios'

export const saveCopyOrder = (order) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/save-copy-order.json.php', order)
      .then((response) => {
        if (response.data.error) {
          reject(response.data)
        } else {
          resolve(response.data)
        }
      })
      .catch((error) => reject())
  })
}
